module.exports = __webpack_public_path__ + "static/img/banner.901be3ec.png";